import Dropdown from "components/molecules/Dropdown";

interface DropdownOptionsProps {
    defaultPageSize?: number;
    field?: string; // The field to update in the mutateDataQuery
    key: string; // The key in the record to display (can be a nested value)
    optionsKey?: string; // The key to use for the option's display name
    optionsValue?: string; // The key to use for the option's value
    optionsQuery?: any; // The query to fetch the options for the dropdown
    mutateDataQuery: any;
}

interface DropdownColumnProps {
    feedType: string;
    isLoading: boolean;
    key: string;
    title: string;
    dropdownOptions: DropdownOptionsProps[];
}

const dropdownColumn = ({
    feedType,
    key,
    title,
    dropdownOptions,
}: DropdownColumnProps) => {
    return {
        title: title,
        dataIndex: key,
        key: key,
        render: (_, record) => {
            return (
                <div>
                    {dropdownOptions.map((dropdownParams, index) => (
                        <div style={{ marginTop: index > 0 ? "10px" : 0 }} key={index}>
                            <Dropdown
                                dropdownParams={dropdownParams}
                                record={record}
                                feedType={feedType}
                            />
                        </div>
                    ))}
                </div>
            );
        },
    };
};

export default dropdownColumn;
